class DiscountProgressBar extends HTMLElement {
    constructor() {
        super();
        this.customProgressBarContainer = document.querySelector('#custom-tdf-discount-widget');
        this.progressComplete = false;
        this.addedInputEvent = false;
        this.showError = false;
        
        this.watch();
    }

    watch() {
        const self = this;
        const targetNode = document.body;
        const observerOptions = {
        childList: true,
        subtree: true
        };

        const observer = new MutationObserver(function(mutations) {
            
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                let divs = document.getElementsByTagName('div');
                
                for (let i = 0; i < divs.length; i++) {
                    if (divs[i].classList.contains('tdf_notify')) {
                        // Display error message
                        self.generatesError();

                        if (!self.addedInputEvent) {
                            self.addedInputEvent = true;
                            self.input = document.querySelector('.tdf_input_discount');
                            self.input.addEventListener('input', self.onChange.bind(self));
                            // self.input.addEventListener('change', self.onChange.bind(self));
                        }
                        
                        // div with class "your-class" already exists
                        break;
                    } else if (divs[i].getAttribute("id") == 'tdf_discount_widget') {
                        const childElement = divs[i].querySelector('.tdf_motivator');
                        
                        if (!childElement) {
                            self.generateCompleteProgress(divs[i]);
                        } else {
                            self.customProgressBarContainer.innerHTML = '';
                        }
                    } else if (divs[i].getAttribute("id") == 'tdf_discount_box') {
                        const inputElement = divs[i].querySelector('.tdf_input_discount');

                        if (inputElement) {
                            inputElement.placeholder = "Enter your discount code here";
                        }
                    }
                }
                }
            });
        });

        observer.observe(targetNode, observerOptions);
    }

    onChange() {
        if (!this.showError) {
            return;
        }
        
        this.showError = false;
        const errorElement = this.querySelector(".error");
        if (errorElement) {
            errorElement.remove();
        }
    }

    generateCompleteProgress(widget) {
        if (!this.progressComplete) {
            widget.setAttribute('style', 'display: none !important');
var discountMessage =  "Great! You’ve qualified for Free Shipping.";
if (Shopify.locale == 'zh-TW' || Shopify.locale == 'tw') {
discountMessage =  "太好了！ 我們為您的訂單添加了15%折扣優惠！";
}
if (! jQuery('#tdf_discount_widget .tdf_discount_tag_freeship').length) {
 discountMessage =  "Great! We've applied a delicious 15% discount to your order!";
if (Shopify.locale == 'zh-TW' || Shopify.locale == 'tw' ) {
discountMessage =  "太好了！ 我們為您的訂單添加了15%折扣優惠！";
}
}
            var progressTemplate = '<div class="tdf_motivator tdf_container"><div class="tdf_motivator_container">' + discountMessage + '<div class="tdf_motivator_border"><div class="tdf_motivator_progress" style="width:100%"></div></div></div></div>';


            this.customProgressBarContainer.innerHTML = progressTemplate;

            this.progressComplete = true;
        }
    }

    generatesError() {
        if (!this.showError) {
            const parentElement = this.querySelector("#tdf_discount_box");
            const newElement = document.createElement("p");
            newElement.className = "error";
            newElement.innerHTML = "The promo code you entered is invalid. Please try again.";
            parentElement.appendChild(newElement);

            this.showError = true;
        }
    }
}

customElements.define('discount-progress-bar',  DiscountProgressBar);